import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {

  // Set item in local storage
  setItem(key: string, value: unknown): void {
    const jsonValue = JSON.stringify(value);
    localStorage.setItem(key, jsonValue);
  }

  // Get item from local storage
  getItem<T>(key: string): T | null {
    const jsonValue = localStorage.getItem(key);
    return jsonValue ? JSON.parse(jsonValue) : null;
  }

  // Remove item from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Check if an item exists in local storage
  exists(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }

  // Clear local storage
  clear(): void {
    localStorage.clear();
  }
}
